import gsap from "gsap";

import Experience from "../Experience";

function tween (target, autoAlpha) {
  gsap.to(target, { autoAlpha, ease: "none" });
}

export default class Overlays {
  constructor () {
    this.experience = new Experience();
    this.resources = this.experience.resources;
    this.container = document.querySelector(".overlays");

    this.hybrid = {};
    this.growth = {};

    this.setInstances();

    this.hide();
  }

  setInstances () {
    this.hybrid.runway = this.resources.items.hybridRunway;
    this.hybrid.runway.dataset.section = "section-2 section-4";
    this.container.appendChild(this.hybrid.runway);

    this.hybrid.taxilanes = this.resources.items.hybridTaxi;
    this.hybrid.taxilanes.dataset.section = "section-2 section-4";
    this.container.appendChild(this.hybrid.taxilanes);

    this.growth.runway = this.resources.items.growthRunway;
    this.growth.runway.dataset.section = "section-2 section-4";
    this.container.appendChild(this.growth.runway);

    this.growth.taxilanes = this.resources.items.growthTaxi;
    this.growth.taxilanes.dataset.section = "section-2 section-4";
    this.container.appendChild(this.growth.taxilanes);

    this.growth.coverage = this.resources.items.cameraCoverage;
    this.growth.coverage.dataset.section = "section-1";
    this.container.appendChild(this.growth.coverage);
  }

  show (hotspot) {
    const group = this.experience.world.isGrowth ? this.growth : this.hybrid;

    for (const target of Object.values(group)) {
      const section = target.dataset.section;
      if (section.includes(hotspot.dataset.section) || section === "all") {
        tween(target, 1);
      } else {
        tween(target, 0);
      }
    }
  }

  hide () {
    for (const target of Object.values(this.growth)) {
      tween(target, 0);
    }

    for (const target of Object.values(this.hybrid)) {
      tween(target, 0);
    }
  }
}